import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { GetProductionWorkflowErrorLogsDto } from "../../../core/models/project-workflow/getProductionWorkflowErrorLogsDto";
import { LoaderService } from "../../../core/services/loader.service";
import { ProjectWorkflowService } from "../../../core/services/project-workflow.service";
import { DialogModule } from "primeng/dialog";
import { CommonModule } from "@angular/common";
import { TableModule } from "primeng/table";

@Component({
  selector: "jni-workflow-error-logs",
  templateUrl: "./workflow-error-logs.component.html",
  styleUrls: ["./workflow-error-logs.component.scss"],
  imports: [DialogModule, CommonModule, TableModule],
})
export class WorkflowErrorLogsComponent implements OnInit {
  @Input() workflowId = 0;
  @Input() errorLogsModal = false;
  @Output() closeErrorLogsModalEvent = new EventEmitter();

  errorLogs: GetProductionWorkflowErrorLogsDto[] = [];

  constructor(
    private _loaderService: LoaderService,
    private _workflowService: ProjectWorkflowService
  ) {}

  ngOnInit(): void {
    this.getReassignedWorkflowLogs();
  }

  closeWorkflowLogsModal() {
    this.closeErrorLogsModalEvent.emit();
  }

  getReassignedWorkflowLogs() {
    this._loaderService.setLoaderState(true);
    this._workflowService
      .getProductionWorkflowErrorLogs(this.workflowId)
      .subscribe({
        next: res => {
          if (res?.status === "Success" && res?.data) {
            this.errorLogs = res.data;
          }
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }
}
